export default "__VITE_ASSET__BbKoXm4R__"